'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'knife-kitchen';
var width = 576;
var height = 512;
var aliases = [128298];
var unicode = 'f6f5';
var svgPathData = 'M480 0L278.6 201.4 392.5 315.2 448 272 448 208 568 88 480 0zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm72-72a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM400 368l-34.6-34.6-33.9 33.9c-11.7 10.1-26.1 21.7-42.8 33.2-48.3 33.4-110.6 63.5-176.7 63.5-9 0-17.7-.8-25.9-2.2L256 291.9 289.9 257.9 256 224 222.1 257.9 35.2 444.8 0 480s18 12 46.6 21.3c18.1 5.9 40.6 10.7 65.4 10.7 110 0 204.9-68.1 253.5-110.6 4.4-3.8 8.4-7.5 12-10.9 14.5-13.5 22.5-22.5 22.5-22.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faKnifeKitchen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;